import AccountManager from 'lib/AccountManager';
import AppsManager from 'lib/AppsManager';

const createActions = store => ({
  action: {
    setCurrentUser: user => store.setState({ user }),
    getCurrentUser: async () => {
      const { currentUser, currentCustomer, products } = await AccountManager.init(true);

      if (currentUser && currentCustomer && products) {
        AppsManager.clearAppsStore();

        const { apps } = products;
        apps.forEach((app) => {
          AppsManager.addApp(app);
        });

        store.setState({
          currentUser,
          currentCustomer,
          products: {
            ...store.state.products,
            apps: AppsManager.apps(),
          },
        });
      }
    },
  },
  state: {
    history: store.state.history,
    currentUser: store.state.currentUser,
    currentCustomer: store.state.currentCustomer,
    products: store.state.products,
    availableParseServerVersions: store.state.availableParseServerVersions,
  },
});

export default createActions;
